import 'bootstrap';

(function ($) {
  'use strict';

  /* Mobile Navigation Toggle
  ========================================================================== */

  const $headerNavigation = $('.header-navigation');
  $(document).on('click', '.mobile-navigation-toggle', function (event) {
    event.preventDefault();
    $(this).toggleClass('active');
    $headerNavigation.toggleClass('mobile-navigation-open');
  });

  // Click outside to close
  $(document).on('click', function (event) {
    const $target = $(event.target);
    if ($headerNavigation.hasClass('mobile-navigation-open')
      && $target.closest('.site-header').length == 0) {
      $headerNavigation.removeClass('mobile-navigation-open');
      $('.mobile-navigation-toggle').removeClass('active');
    }
  });


  /* Desktop Search Toggle
  ========================================================================== */

  const $searchToggle = $('.desktop-search-toggle');
  $(document).on('click', '.desktop-search-toggle', function (event) {
    event.preventDefault();
    $(this).toggleClass('active');
    $searchToggle.find('.icon-search').toggleClass('hidden');
    $searchToggle.find('.icon-close').toggleClass('hidden');
    $headerNavigation.toggleClass('desktop-search-open');
  });


  /* Enable Tooltips
  ========================================================================== */
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });


  /* Filter posts
  ========================================================================== */

  const $mobileFilter = $('.archive-filter select');
  const $desktopFilterLinks = $('.archive-filter ul a');
  const $posts = $('.archive-content [data-tags]');
  const $document = $(document);
  const $hash = $(location).attr('hash');

  // Visitor arrived on this page via a tag link
  if ($hash) {
    let tag = $hash.substring(1);

    // Select matching tag from dropdown on mobile
    $mobileFilter.val(tag);

    // Select matching tag link on desktop
    $desktopFilterLinks.removeClass('active');
    $desktopFilterLinks.filter('[data-tag="' + tag + '"]').addClass('active');

    filterByTag(tag);

  } else {

    // Set dropdown to "Show All" (in case the browser retains a previous selection on page load)
    $mobileFilter.val('');
  }

  // Desktop Links
  $desktopFilterLinks.on('click', function () {

    // Skip if already active
    if ($(this).hasClass('active'))
      return;

    // Visually mark as active
    $desktopFilterLinks.removeClass('active');
    $(this).addClass('active');

    filterByTag($(this).data('tag'));
  });

  // Mobile Dropdown
  $mobileFilter.on('change', function () {
    $document.scrollTop($mobileFilter.offset().top - 32);
    filterByTag($(this).val());
  });

  function filterByTag(tag) {
    let hash = '';
    if (tag) {
      // Show matching posts
      $posts.hide().filter('[data-tags*="' + tag + '"]').fadeIn();
      hash = '#' + tag;
    } else {
      // Show all posts
      $posts.hide().fadeIn();
    }

    // Change anchor in URL
    history.replaceState('', document.title, window.location.pathname + hash);
  }

}(jQuery));